import Swal from 'sweetalert2'
import DemonstracaoService from '../services/DemonstracaoService'

export async function solicitarDemonstracaoSeBloqueado(recurso: string, aoFechar?: () => void) {
  const swal = Swal.mixin({
    customClass: { confirmButton: 'btn btn-primario ms-5', cancelButton: 'btn btn-modal-cancelar' },
    buttonsStyling: false
  })

  // Evita reabrir a modal de confirmação e recriar o mesmo Lead no Pipedrive se esse cliente já
  // tiver solicitado demonstração desse recurso antes (mesmo bloqueio do backend, mas aqui evita
  // até a chamada de criação do lead).
  const jaSolicitado = await DemonstracaoService.jaSolicitado(recurso)
  if (jaSolicitado) {
    await swal.fire({
      title: 'Demonstração já solicitada',
      text: `Você já solicitou uma demonstração do recurso "${recurso}". Nosso time comercial já está ciente e vai entrar em contato.`,
      icon: 'info',
      confirmButtonText: 'Ok',
    })
    aoFechar?.()
    return
  }

  const result = await swal.fire({
    title: 'Recurso não incluído no seu plano',
    text: `Deseja agendar uma demonstração do recurso "${recurso}"?`,
    showCancelButton: true,
    cancelButtonText: 'Cancelar',
    confirmButtonText: 'Agendar demonstração',
    reverseButtons: true,
  })

  // result.isConfirmed é false tanto pro botão "Cancelar" quanto pra qualquer
  // outra forma de fechar a modal (X, clique fora, Esc) — em todos esses casos
  // o usuário não pode ficar parado na tela bloqueada, então volta pra rota segura.
  if (!result.isConfirmed) {
    aoFechar?.()
    return
  }

  const ok = await DemonstracaoService.solicitar(recurso)
  if (ok) {
    await Swal.fire({ text: 'Solicitação enviada! Nosso time comercial vai entrar em contato.', icon: 'success' })
  }

  // Confirmado ou não o agendamento, o usuário não tem acesso ao recurso —
  // não pode ficar parado na tela bloqueada, então volta pra rota segura.
  aoFechar?.()
}
